import Vue from 'vue'
import router from './router/index'
// import VueAxios from 'vue-axios'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// 各API接口
import api from './api/api' // 导入api接口
// 首页模板
import App from './components/page/App.vue'
// 状态管理
import store from './vuex/store'

// 全局参数
const publicData = {
}

Vue.prototype.publicData = publicData

Vue.config.productionTip = false
Vue.prototype.$api = api // 将api挂载到vue的原型上
// Vue.prototype.$url = 'http://runbang_server.shanmuzhi.com' // 域名，后边图片地址拼接用测试服
// Vue.prototype.$url = 'https://console.dzrbhb.com' // 域名，后边图片地址拼接用正式服
Vue.prototype.$url = '' // 域名，后边图片地址拼接用正式服
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
